export * from './AccommodationPageLink'
